export default "__VITE_ASSET__B487A_11__"